import { createStore } from 'vuex';
import userDataDetails from '@/store/universal/userdata-details';
import cardWidgetList from '@/store/universal/card-widget-list';
import counteragentNsi from '@/store/counteragent/counteragent-nsi';
import nsiEditor from '@/store/nsi/nsi-editor';
import roles from '@/store/administration/roles';
import users from '@/store/administration/users';
import registryGrid from '@/store/registry-grid';
import registryTreeList from '@/store/registry-tree-list';
import eosrcEoru from '@/store/e-grid/eosrc-eoru';
import eosrcEotrans from '@/store/e-grid/eosrc-eotrans';
import eosrcEofider from '@/store/e-grid/eosrc-eofider';
import eosrcEoschema from '@/store/e-grid/eosrc-eoschema';
import eosrcEoschemaFull from '@/store/e-grid/eosrc-eoschema-full';
import historyData from '@/store/history/history-data';

const store = createStore({
    modules: {
        userDataDetails,
        cardWidgetList,
        counteragentNsi,
        nsiEditor,
        roles,
        users,
        registryGrid,
        registryTreeList,
        eosrcEoru,
        eosrcEotrans,
        eosrcEofider,
        eosrcEoschema,
        eosrcEoschemaFull,
        historyData
    },
});

export default store;
